import {API_URL} from "../../../components/config/BaseUrl";

export const GET_ROBOCALLS_URL = `${API_URL}/wificall/robocall?cardid=${sessionStorage.getItem('cardid')}`;
export const CREATE_ROBOCALL_URL = `${API_URL}/wificall/robocall`;